import { Injectable, Renderer2, RendererFactory2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private renderer: Renderer2;
    private isBrowser: boolean;

    constructor(
        rendererFactory: RendererFactory2,
        @Inject(PLATFORM_ID) private platformId: object,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    /**
     * Sets a single CSS variable on the :root element.
     */
    setCSSVariable(variable: string, value: string): void {
        if (this.isBrowser) {
            this.renderer.setStyle(this.document.documentElement, variable, value);
        }
    }

    /**
     * Sets multiple CSS variables from an object.
     */
    setTheme(colors: { [key: string]: string }): void {
        if (this.isBrowser && colors) {
            Object.keys(colors).forEach((key) => {
                document.documentElement.style.setProperty(key, colors[key]);
                this.renderer.setStyle(this.document.documentElement, key, colors[key]);
                // console.log(key, colors[key]);
                // console.log();

            });

        }
    }

    /**
     * Applies a predefined theme by name. This looks up a JSON of themes and sets the CSS variables.
     * If the theme doesn't exist, it will do nothing or you can default to a particular theme.
     */
    applyTheme(theme: any): void {
        if (theme) {
            this.setTheme(theme);
        } else {
            console.warn(`Theme not found. Please check the THEMES object.`);
        }
    }
}
